/**
 * Sorts two dates by earliest date first.
 * @param dateA Any string that can act as an argument to the Date constructor, such as "2019-12-31"
 * @param dateB Any string that can act as an argument to the Date constructor, such as "2019-12-31"
 */
export const sortByEarliestDate = (
    dateA: Maybe<string>,
    dateB: Maybe<string>,
): number => {
    if (dateA === null || dateB === null) {
        return 0;
    }

    const dateInstanceA = new Date(dateA);
    const dateInstanceB = new Date(dateB);

    if (dateInstanceA > dateInstanceB) {
        return 1;
    }

    if (dateInstanceA < dateInstanceB) {
        return -1;
    }

    return 0;
};
